import { render } from "./Sidebar.vue?vue&type=template&id=47313574&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=47313574&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47313574"]])

export default __exports__